import React from 'react';

import parallax1 from '../assets/images/parallax-1.jpg'
import parallax2 from  '../assets/images/salle-musculation.jpg'

import { Parallax, Background } from "react-parallax";

const styles = {
    fontFamily: "sans-serif",
    textAlign: "start"
  };

const insideStyles = {
    background: "white",
    padding: 20,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-70%,-50%)",
};

function Home() {
    return(
        <div style={styles}>
            <Parallax bgImage={parallax1} strength={200}>
            <div style={{ height: 600, padding:20}}>
                <div style={insideStyles}>Association de trail à l'ambiance familiale, nous courons, roulons et tout ça en montagne. Les beaux paysages sont notre motivation.</div>
            </div>
            </Parallax>
            <h2></h2>
            <Parallax bgImage={parallax2} blur={{ min: -1, max: 3 }}>
            <div style={{ height: 500 }}>
                <div style={insideStyles}>Dynamic Blur</div>
            </div>
            </Parallax>
            <h2></h2>
            <Parallax
                bgImage={parallax1}
                strength={200}
                renderLayer={(percentage) => (
                    <div>
                    <div
                        style={{
                        position: "absolute",
                        background: `rgba(255, 125, 0, ${percentage * 1})`,
                        left: "50%",
                        top: "50%",
                        borderRadius: "50%",
                        transform: "translate(-50%,-50%)",
                        width: percentage * 500,
                        height: percentage * 500
                        }}
                    />
                    </div>
                )}
                >
                <div style={{ height: 500 }}>
                    <div style={insideStyles}>renderProp</div>
                </div>
            </Parallax>
            <h2>| | |</h2>
            <Parallax strength={500}>
                <Background className="custom-bg">
                    <div
                    style={{
                        height: 2000,
                        width: 2000,
                        backgroundImage: "url('https://i.imgur.com/8CV5WAB.png')"
                    }}
                    />
            </Background>
            <div>
                <br />
                custom background component
                <br />
                <br />
                custom background component
                <br />
                <br />
                custom background component
                <br />
                <br />
            </div>
            </Parallax>
            <div style={{ height: 500 }} />
            <h2>{"\u2728"}</h2>
        </div>
    );
}

export default Home;